// Accepts item (string) and data (JSON)

import { useState } from 'react';

import { Routes } from '../constants';

// Hook
export default function useLocalStorage(key: string, initialValue?: any) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window ? window.localStorage.getItem(key) : null;
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      // eslint-disable-next-line no-console
      // console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value: any) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (window)
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      // A more advanced implementation would handle the error case
      // eslint-disable-next-line no-console
      // console.log(error);
    }
  };
  return [storedValue, setValue];
}

export const setLocalStorageItem = (item: string, data: any) => {
  if (localStorage)
    localStorage.setItem(
      item,
      typeof data === 'object' ? JSON.stringify(data) : data
    );
};

// Accepts item (string) and returns JSON data
export const getLocalStorageItem = (item: string) => {
  const receivedItem =
    !(typeof window === 'undefined') && localStorage && item in localStorage
      ? localStorage.getItem(item)
      : '';

  try {
    return receivedItem ? JSON.parse(receivedItem) : '';
  } catch (e) {
    return receivedItem;
  }
};

export const handleLogoutSession = () => {
  localStorage.removeItem('auth');
  window.location.href = Routes.HOME;
};

export const localstorageKeys = {
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  AUTH_TOKEN: 'AUTH_TOKEN',
  USER_DATA: 'USER_DATA',
};
